import Vue from "vue"

export default {
  GetLocalization (lang) {
    return require(`./${lang}.json`)
  }
}
